import { MouseEvent, ReactElement, useState } from "react";
import { Button } from "@twilio-paste/core/button";
import { Paragraph } from "@twilio-paste/core/paragraph";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalHeading,
  ModalFooterActions,
} from "@twilio-paste/core/modal";
import { copy, EndChatButtonProps } from "./definitions";

const EndChatButton = ({ onConfirm }: EndChatButtonProps): ReactElement => {
  const modalHeadingID = "end-chat-modal-heading";
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);
  const handleConfirm = (event: MouseEvent<HTMLButtonElement>) => {
    setLoading(true);
    handleClose();
    onConfirm(event);
  };

  return (
    <>
      <Button
        variant="secondary"
        size="rounded_small"
        onClick={handleOpen}
        loading={loading}
      >
        {copy.button}
      </Button>
      <Modal
        ariaLabelledby={modalHeadingID}
        isOpen={isModalOpen}
        onDismiss={handleClose}
        size="default"
      >
        <ModalHeader>
          <ModalHeading as="h3" id={modalHeadingID}>
            {copy.modal.header}
          </ModalHeading>
        </ModalHeader>
        <ModalBody>
          <Paragraph>{copy.modal.body}</Paragraph>
        </ModalBody>
        <ModalFooter>
          <ModalFooterActions>
            <Button variant="secondary" onClick={handleClose}>
              {copy.modal.actions.close}
            </Button>
            <Button variant="primary" onClick={handleConfirm}>
              {copy.modal.actions.confirm}
            </Button>
          </ModalFooterActions>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EndChatButton;
